<template>
    <div class="strategy-trees">
        <div class="tree-search-input">
            <ConditionSearch
                :resData="resData"
                @conditionInputChange="conditionInputChange"
                @showSearchList="showSearchList"
                :placeholder="placeholder"
                @searchInputChange="conditionInputChange"
            />
        </div>
        <EditTree
            class="trees-container"
            :datas="treeData"
            :editable="true"
            :maxLevel="5"
            :current="currentUrl"
            @nodeSelected="treeSelect"
            @nodeExpanded="treeExpand"
            @nodeOperate="treeOperate"
        />
    </div>
</template>

<script>
import ConditionSearch from "@/views/zhiji/bComponents/inputs/ConditionSearch";
import EditTree from "@/views/zhiji/bComponents/trees/EditTree";
import AddClassifyMaterial from "./AddClassifyMaterial";
import { filterTreeData, getParentTree, updataTreeData } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

export default {
    name: "MaterialTrees",
    props: ["type"],
    components: {
        ConditionSearch,
        EditTree
    },
    data() {
        return {
            resData: [],
            currentUrl: ""
        };
    },
    computed: {
        treeData() {
            return this.getStorePorp("treeData");
        },
        placeholder() {
            return this.$t("zhiji.materialLibrary.searchClassify");
        }
    },
    watch: {
        // 监控中英文切换，重新获取接口数据
        placeholder() {
            this.$store.dispatch("zhiji/queryTagTreesList", { type: this.type });
        }
    },
    mounted() {
        this.$store.dispatch("zhiji/queryTagTreesList", { type: this.type });
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.materialLibraryPage[propName];
        },
        showSearchList(data) {
            this.resData = filterTreeData(this.treeData.children, data.searchInfo);
        },
        conditionInputChange(data) {
            let result = getParentTree(this.treeData.children, data.keywords);
            this.currentUrl = result.path;
        },
        treeSelect(data) {
            if (data.isRoot) {
                this.$emit("getItemDetail", {
                    isRoot: data.isRoot
                });
                this.$store.dispatch("zhiji/queryTagTreesList", { type: this.type });
            } else if (this.treeData.children) {
                updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                    this.$emit("getItemDetail", {
                        tagId: parseInt(treeData.id)
                    });
                });
            }
            this.currentUrl = data.path;
        },
        treeExpand() {},
        treeOperate(data) {
            let handler = {
                edit: this.editAction,
                delete: this.deleteAction,
                add: this.addAction,
                transfer: this.transferAction
            };
            handler[data.opr].call(null, data);
        },
        editAction(data) {
            updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                treeData.label = data.newLabel;
                this.$store.dispatch("zhiji/updateMaterialTagTrees", {
                    type: this.type,
                    ...treeData
                });
            });
        },
        deleteAction(data) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.common.deleteConfim") + data.label + "？",
                    confirm: () => {
                        updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                            this.$store.dispatch("zhiji/deleteMaterialTagTrees", {
                                type: this.type,
                                ...treeData
                            });
                        });
                    }
                }
            });
        },
        addAction(data) {
            this.$store.dispatch("zhiji/showModal", {
                type: AddClassifyMaterial,
                data: {
                    type: this.type,
                    ...data,
                }
            });
        },
        transferAction(data) {
            updataTreeData(this.treeData.children, data.path.split("/"), treeData => {
                this.$store.dispatch("zhiji/moveMaterialTagTrees", {
                    classId: treeData.id,
                    order: data.newIdx,
                    type: this.type,
                });
            });
        }
    }
};
</script>

<style scoped lang="less">
.strategy-trees {
    width: 272px;
    height: 100%;
    padding: 12px 0;
    font-size: 12px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    border-right: 1px solid #e3ecf5;
    background: #f2f7fd;
    overflow-x: hidden;
    overflow-y: auto;
    .tree-search-input {
        width: auto;
        margin: 0 10px 10px 16px;
        position: relative;
    }
    .trees-container {
        height: calc(100% - 50px);
    }
}
</style>
